import website from '../assets/website.png'
import instagram from '../assets/instagram.png'
import appstore from '../assets/playstore.png'
import youtube from '../assets/youtube.jpeg'
import dribbble from '../assets/dribbble.png'
import github from '../assets/github.png'
import telegram from '../assets/telegram.png'
import twitter from '../assets/twitter.png'

const items = [{
    "title": "Website",
    "subtitle": "Look at my work!",
    "image": website,
    "link": "https://samuelmaciel.com.br" //your personal website or portfolio  link
},
{
    "title": "YouTube",
    "subtitle": "Samuka Maciel - Descomplicando sua Jornada Fitness  | Official channel of mine",
    "image": youtube,
    "link": "https://www.youtube.com/c/samuelmaciel92"//youtube channel link 
},
{
    "title": "Instagram",
    "subtitle": "@samukamaciel | Hub of my awesome 😎 pics",
    "image": instagram,
    "link": "https://instagram.com/samukamaciel" //instagram profile link 
},
{
    "title": "Telegram",
    "subtitle": "@Samukamaciel | Chat with me instantly, Don't hesitate! ",
    "image": telegram,
    "link": "https://t.me/Samukamaciel" //Telegram Pofile 
},
{
    "title": "Twitter",
    "subtitle": "@ssmaciel | Don't forget to follow me 😉",
    "image": twitter,
    "link": "https://twitter.com/ssmaciel"// twitter profile link 
},
// {
//     "title": "YouTube",
//     "subtitle": "Samuka Tech - Desenvolvimento & Tecnologias  | Official channel of mine",
//     "image": youtube,
//     "link": "https://www.youtube.com/c/samuelmaciel92"//youtube channel link 
// },
{
    "title": "GitHub",
    "subtitle": "@ssmaciel | 🏠 of my open-source projects",
    "image": github,
    "link": "https://github.com/ssmaciel" //Github Profile link
}]

export default items
